import React from 'react';
import { Select } from 'antd';

const specialRegimeOptions = [
  {
    label: 'Microempresa Municipal',
    value: 'municipalMicroenterprise'
  },
  {
    label: 'Estimativa',
    value: 'estimate'
  },
  {
    label: 'Sociedade de Profissionais',
    value: 'societyOfProfessionals'
  },
  {
    label: 'Cooperativa',
    value: 'cooperative'
  },
  {
    label: 'Microempresário Individual (MEI)',
    value: 'individualMicroenterprise'
  },
  {
    label: 'Microempresário e Empresa de Pequeno Porte (ME EPP)',
    value: 'microenterpriseAndSmallBusiness'
  }
];

const SelectSpecialTaxRegime = (props) => {
  return (
    <Select {...props}>
      {specialRegimeOptions.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectSpecialTaxRegime;
